import { getLoggerManager } from '@/shared/logging'

/** 公共 System 配置：用户请求的 system-wide 排序策略。 */
export type GSplatSortingMode = 'auto' | 'cpu' | 'gpu'

/** capability transaction 最终提交的实际排序管线。 */
export type GSplatResolvedSortingMode = Exclude<GSplatSortingMode, 'auto'>

/** 内部 Params.renderer 接受 AUTO；不得作为公共 sortingMode 泄漏。 */
export type GSplatRendererRequest = GSplatSortingMode

/** 内部 Params.currentRenderer / Manager.activeRenderer 的已解析选择。 */
export type GSplatResolvedRenderer = GSplatResolvedSortingMode

const sortingLog = getLoggerManager().getLogger('gsplat:sorting')
let webglGpuFallbackReported = false

/** 在 requested/resolved transaction 成功提交后报告 WebGL GPU 请求的兼容回退。 */
export function reportGSplatSortingFallbackOnce(
  backend: string,
  requested: GSplatSortingMode,
  resolved: GSplatResolvedSortingMode
): void {
  if (
    webglGpuFallbackReported ||
    backend !== 'webgl2' ||
    requested !== 'gpu' ||
    resolved !== 'cpu'
  ) {
    return
  }
  webglGpuFallbackReported = true
  sortingLog.warn(
    'GSplat sortingMode=gpu 在 WebGL2 上按兼容规则解析为 cpu；请读取 resolvedSortingMode 确认实际管线'
  )
}

declare const GSPLAT_RENDER_PASS_MASK_BRAND: unique symbol

/** Renderer forward/shadow participation bitmask；不得接收 sorting/renderer selection。 */
export type GSplatRenderPassMask = number & {
  readonly [GSPLAT_RENDER_PASS_MASK_BRAND]: 'GSplatRenderPassMask'
}

export const GSPLAT_RENDER_MODE_NONE = 0 as GSplatRenderPassMask
export const GSPLAT_RENDER_MODE_FORWARD = 1 as GSplatRenderPassMask
export const GSPLAT_RENDER_MODE_SHADOW = 2 as GSplatRenderPassMask

export function combineGSplatRenderPasses(
  ...passes: readonly GSplatRenderPassMask[]
): GSplatRenderPassMask {
  return passes.reduce<number>((mask, pass) => mask | pass, 0) as GSplatRenderPassMask
}

export function hasGSplatRenderPass(
  mask: GSplatRenderPassMask,
  pass: GSplatRenderPassMask
): boolean {
  return (mask & pass) !== 0
}
